import { render, staticRenderFns } from "./CustomizeCertificateCompo.vue?vue&type=template&id=8b13417a&"
import script from "./CustomizeCertificateCompo.vue?vue&type=script&lang=js&"
export * from "./CustomizeCertificateCompo.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeCertificateCompo.vue?vue&type=style&index=0&id=8b13417a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports